'use client';

import PropTypes from 'prop-types';
import { BLOGS_PATH } from '@/consts/routes';
import NewsPage from './NewsPage';

const BLOGS_INTRO_COPY =
  'Explore insights, project stories, and design perspectives from the NIICO team. Stay inspired with ideas that help shape timeless, thoughtfully crafted spaces.';

export default function BlogsPage({ articles }) {
  return (
    <NewsPage
      articles={articles}
      basePath={BLOGS_PATH}
      headerTitle="Blogs"
      introCopy={BLOGS_INTRO_COPY}
      emptyMessage="No blog posts available yet."
    />
  );
}

BlogsPage.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
      coverSrc: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
